export function create_visualizers_container(visualizers, viewer, always_update = false) {
    const list = Object.values(visualizers);
    const update = () => list.forEach(v => v.update());
    let update_observer = always_update ? viewer.get_update_observable().add(update) : null;
    const dispose = () => {
        list.forEach(v => v.dispose());
        update_observer === null || update_observer === void 0 ? void 0 : update_observer.dispose();
        update_observer = null;
    };
    return Object.assign({ update: update, dispose: dispose, get always_update() {
            return !!update_observer;
        },
        set always_update(v) {
            if (v === !!update_observer)
                return;
            if (v) {
                update_observer = viewer.get_update_observable().add(update);
            }
            else {
                update_observer === null || update_observer === void 0 ? void 0 : update_observer.dispose();
                update_observer = null;
            }
        } }, visualizers);
}
//# sourceMappingURL=VisualizersContainer.js.map